module.exports = __webpack_public_path__ + "static/media/home.92666d20.svg";